import { useState } from "react";

import FechamentoMesaDialog from "./FechamentoMesaDialog";
import TrocoModal from "../../../components/TrocoModal";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../../components/ui/alert-dialog";
import { useFechamentoPedido } from "../hooks/useFechamentoPedido";
import { brl } from "../lib/formato";

/**
 * Finalizar pedido de RETIRADA no Delivery com o mesmo popup do Fechar mesa
 * (dividir, pagar por produto/quantidade, várias formas, desconto). Quem chama
 * passa `onConcluir(conta)`, que grava o pedido e conclui.
 */
export default function FechamentoPedidoDialog({ pedido, formas, open, onOpenChange, onConcluir }) {
  const [trocoAberto, setTrocoAberto] = useState(false);
  const [confirmarSaida, setConfirmarSaida] = useState(false);
  const f = useFechamentoPedido({ pedido, formas, onConcluir, open, onOpenChange, abrirTroco: () => setTrocoAberto(true) });

  // Fechar com parte já paga pede confirmação: o que foi pago fica guardado
  // neste computador e volta ao reabrir o pedido
  const aoMudarAberto = (aberto) => {
    if (!aberto && f.total.pago > 0 && f.pagamento.rotuloBotao == null) { setConfirmarSaida(true); return; }
    onOpenChange(aberto);
  };

  if (!pedido) return null;
  return (
    <>
      <FechamentoMesaDialog f={{ ...f, onOpenChange: aoMudarAberto }} />
      <TrocoModal
        open={trocoAberto}
        onOpenChange={setTrocoAberto}
        total={f.pagamento.total}
        onConfirm={f.pagamento.setRecebido}
      />
      <AlertDialog open={confirmarSaida} onOpenChange={setConfirmarSaida}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Sair com o pagamento pela metade?</AlertDialogTitle>
            <AlertDialogDescription>
              Já foram recebidos {brl(f.total.pago)} e faltam {brl(f.total.restante)}. O que foi pago fica guardado
              neste computador e volta quando você abrir o Finalizar deste pedido de novo. Nada vai pro caixa até
              a última parte.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Continuar recebendo</AlertDialogCancel>
            <AlertDialogAction onClick={() => { setConfirmarSaida(false); onOpenChange(false); }}>Sair</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
